var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button is-small pause",on:{"click":function($event){_vm.commentModalOpen = true}}},[_vm._v("Kommentar anlegen")]),(_vm.commentModalOpen)?_c('CommentModal',{attrs:{"has-ctas":false},on:{"close":function($event){_vm.commentModalOpen = false}}},[_c('Comments')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }